import useTranslation from "utils/hooks/useTranslation";
import { Popup } from "./Popup";
import Button from "components/shared/button";
import { SvgCommandDownload } from "components/svg";

interface NeedHelpProps {
  closePopup: () => void;
}

const NeedHelpPopup: React.FC<NeedHelpProps> = (
//  { closePopup }
) => {
  const { t } = useTranslation();

  return <>
    <Popup
      title={t("MY_ACCOUNT")}
      translateTitle
      fixSize={"medium"}
      commandPanelProps={{
        additionalElement: (
          <group data-justify="center" data-gap="20">
            <Button
              data-length="forcefit"
              //accent
              secondary
              large
              icon={<icon data-svg-size="16" data-svg-color="secondary"><SvgCommandDownload /></icon>}
              simple
              onClick={() => {
                //closePopup();
              }}
            >
              {t("UPLOAD_PDF")}
            </Button>
          </group>
        )
      }}
    >
      <>
        <group data-height="fit" data-space-horizontal="50">
          <group data-space-top="20">
            <picture
              data-ratio="16:9"
              data-radius="extra-special"
              data-background="grey-color-light"
              data-elevation="7"
            >
              <video
                //data-position="absolute"
                //src={`${env.api_url}/${i.video.filepath}`}
                src="https://afdprojipacprd7000.azurefd.net/upload/314_Régler votre compte client.mp4"
                //autoPlay
                //muted
                loop
                //playsInline
                controls={true}
                data-object-fit="cover"
                data-height="fit"
                data-max-length="fit"
              ></video>
            </picture>
          </group>

        </group>
      </>
    </Popup>
  </>
}

export default NeedHelpPopup;